import React from 'react';
import { ICONS } from 'Components/utils/icon/icons';
import { REMAINING_STOCK_LIMIT } from 'Components/utils/accommodation/accommodation.utils';
import { t } from 'Src/i18n';
import { classnames } from 'Utils/classnames/classnames.utils';
import { AccommodationRoomAvailability } from 'Components/widgets/accommodation-room/availability/AccommodationRoomAvailability';
import { Icon } from 'Components/frameworks/icon/Icon';
import { themes } from './AccommodationHeader.themes';
type Props = {
  className?: string;
  hasConsecutiveRooms?: boolean;
  hasHiddenStock?: boolean;
  isCabin: boolean;
  numberOfAdults: number;
  numberOfBabies: number;
  numberOfChildren: number;
  numberOfRooms: number;
  stock: number;
  theme?: keyof typeof themes;
};
export const AccommodationHeader = ({
  className,
  hasConsecutiveRooms = false,
  hasHiddenStock = false,
  isCabin = false,
  numberOfAdults,
  numberOfBabies,
  numberOfChildren,
  numberOfRooms,
  stock,
  theme = 'default',
}: Props) => {
  const { thAlert, thAttendees, thAttendeesNumbers, thRecap, thRooms, thRoot } = themes[theme];
  const totalAttendees = numberOfAdults + numberOfBabies + numberOfChildren;
  return (
    <div className={classnames(thRoot, className)}>
      <div className={thRecap}>
        {totalAttendees > 0 && (
          <p className={thAttendees}>
            {t('booking.accommodation.proposalFor')}{' '}
            <span className={thAttendeesNumbers}>
              {[
                `${numberOfAdults} ${numberOfAdults > 1 ? t('booking.common.adults') : t('booking.common.adult')}`,
                numberOfBabies
                  ? `${numberOfBabies} ${numberOfBabies > 1 ? t('booking.common.babies') : t('booking.common.baby')}`
                  : null,
                numberOfChildren
                  ? `${numberOfChildren} ${numberOfChildren > 1 ? t('booking.common.children') : t('booking.common.child')}`
                  : null,
              ]
                .filter(Boolean)
                .join(' - ')}
            </span>
          </p>
        )}
        {!hasConsecutiveRooms && (
          <p className={thRooms}>
            {numberOfRooms} {t('booking.accommodation.packageContent.separatedRooms')}
          </p>
        )}
        {!hasHiddenStock && stock <= REMAINING_STOCK_LIMIT && (
          <AccommodationRoomAvailability isCabin={isCabin} stock={stock} theme={theme} />
        )}
      </div>
      {!isCabin && (
        <div className={thAlert}>
          <Icon name={ICONS.SEPARATED_BUILDINGS} width="2.5em" />
          {t('booking.accommodation.separatedRooms')}
        </div>
      )}
    </div>
  );
};
